module.exports = __webpack_public_path__ + "media/PAG80-04.6cc6ccf1.mp3";